export default {
  data() {
    return {
      isMobileApp: false,
      MobileApp: null,
    }
  },
  
  methods: {
    checkMobileApp() {
      this.MobileApp = window.ReactNativeWebView?.postMessage || null
      this.isMobileApp = this.MobileApp ? true : false
    },
  },
  mounted() {
    this.checkMobileApp()
  },
}
